export default __webpack_public_path__ + "static/media/device-view.fb2dd1d3.webp";